import Vue from 'vue';
import store from './../../store';
import productGroupTransformer from './../../transformers/productGroup';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const productGroups = productGroupTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);

  store.dispatch('fetchPaginatedProductGroups', { productGroups, pagination });
  resolve();
};

const failed = (error, reject) => reject(error);


export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('product_groups', options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product-group/items.js